<mat-form-field
    [floatLabel]="hasFloatingLabel ? 'always' : 'auto'"
    class="w-full"
    [color]="color"
    [arcErrorTooltip]="control"
    [subscriptSizing]="hasFixedSubscript ? 'fixed' : 'dynamic'">
    @if (!!label || !!labelKey) {
        <mat-label>{{ label || (labelKey | transloco) }}</mat-label>
    }
    <input
        matInput
        [formControl]="castedControl"
        [placeholder]="dateFormat"
        [matDatepicker]="picker"
        [min]="min"
        [max]="max"
        (dateChange)="onChange($event)" />
    <mat-datepicker-toggle matIconSuffix [for]="picker" />
    <mat-datepicker #picker color="primary" />
</mat-form-field>
